import React from 'react';
import {Grid, Link, Snackbar} from '@mui/material';
import shadow from '../assets/shadow.png';
import bottomPic from '../assets/bottom_pic.png';
import Typography from '@mui/material/Typography';
import SvgLogo from './svg/SvgLogo';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import {connect} from 'react-redux';
import {selectCategory, selectTab} from '../store/actions/navigation';
import {useParams} from 'react-router-dom';
import {HashLink} from 'react-router-hash-link';

const Footer = ({pages, driverCategories}) => {
	const {platform = 'all'} = useParams();
	const [snackbar, setSnackbar] = React.useState(null);

	// Hidden admin action: double-click the bottom-right corner of the page
	// re-scrapes the DriverCentral vendor page into the local cache.
	const refreshDrivers = async () => {
		setSnackbar('Refreshing drivers from DriverCentral…');
		try {
			const res = await fetch('/api/drivers/refresh', {method: 'POST'});
			const data = await res.json();
			if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
			setSnackbar(`Refreshed: ${data.count} drivers — reloading…`);
			setTimeout(() => window.location.reload(), 1500);
		} catch (err) {
			setSnackbar(`Refresh failed: ${err.message}`);
		}
	};

	return (
		<div>
			<Box sx={{width: '100%', backgroundColor: '#e0e5e7'}}>
				<img
					src={shadow}
					alt=""
					style={{width: "100%", display: 'block'}}
				/>
				<Container maxWidth="lg" sx={{paddingTop: 3, paddingBottom: 4}}>
					<Grid container spacing={4}>
						<Grid item xs={12} md={5}>
							<SvgLogo width={'180px'}/>
							<Typography variant="body2" sx={{paddingTop: 1}}>
								ABN: 82639873064
							</Typography>
							<Typography variant="caption" component="div" sx={{paddingTop: 2}}>
								For technical support please email:
							</Typography>
							<Link variant="body2" color="text.primary" underline="hover"
							      href={'mailto:support@hopsoft.com.au'} display="block">
								support@hopsoft.com.au
							</Link>
							<Link variant="body2" color="text.primary" underline="hover"
							      href={'mailto:admin@hopsoft.com.au'} display="block">
								admin@hopsoft.com.au
							</Link>
						</Grid>
						<Grid item xs={6} md={3}>
							<Typography variant="subtitle2" sx={{paddingBottom: 1}}>
								MENU
							</Typography>
							{pages.map((page) => (
								<Link key={page.path}
								      component={HashLink}
								      variant="body2"
								      color={"text.primary"}
								      underline="hover"
								      display="block"
								      smooth
								      to={`${page.path}#mainPanel`}>
									{page.name}
								</Link>
							))}
						</Grid>
						<Grid item xs={6} md={4}>
							<Typography variant="subtitle2" sx={{paddingBottom: 1}}>
								DRIVERS
							</Typography>
							{driverCategories.map((category) => (
								<Link key={category.value}
								      component={HashLink}
								      variant="body2"
								      color={'text.primary'}
								      underline={'hover'}
								      display="block"
								      smooth
								      to={`/portfolio/${platform}/${category.value}#portfolioBrowser`}>
									{category.name}
								</Link>
							))}
						</Grid>
					</Grid>
				</Container>
				<Box sx={{
					display: 'flex', justifyContent: 'center', alignItems: 'center',
					backgroundColor: '#60cc29',
					minHeight: '40px',
				}}>
					<Typography variant="caption" color={'white'}>
						©{new Date().getFullYear()} by HopSoft | <Link
						variant="caption"
						color="white"
						href={'mailto:admin@hopsoft.com.au'}
						underline="hover">
						admin@hopsoft.com.au
					</Link>
					</Typography>
				</Box>
				<img
					src={bottomPic}
					alt=""
					style={{width: "100%", display: 'block'}}
				/>
			</Box>
			<Box onDoubleClick={refreshDrivers}
			     sx={{position: 'fixed', bottom: 0, right: 0, width: 32, height: 32, zIndex: 10}}/>
			<Snackbar
				open={Boolean(snackbar)}
				autoHideDuration={4000}
				onClose={() => setSnackbar(null)}
				message={snackbar}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		tabSelected: state.navigation.tabSelected,
		categorySelected: state.drivers.categorySelected,
		pages: state.pages,
		driverCategories: state.drivers.driverCategories
	};
};

export default connect(mapStateToProps, {selectTab, selectCategory})(Footer);
